import { Textarea } from '@/lib/components/ui/textarea';
import { Label } from '@/lib/components/ui/label';
import { cn } from '@/lib/lib/utils';
import React from 'react';

interface TextareaWithLabelProps extends React.ComponentProps<typeof Textarea> {
  label: string | React.ReactNode;
  error?: string;
  descriptionText?: string;
}

const TextareaWithLabel = (props: TextareaWithLabelProps) => {
  const { label, error, descriptionText, className, ...rest } = props;

  return (
    <div className="w-full space-y-2">
      {typeof label === 'string' ? (
        <Label className="text-sm font-medium">{label}</Label>
      ) : (
        label
      )}
      <Textarea
        className={cn(
          'text-sm',
          error && 'border-red-500 focus-visible:ring-red-500',
          className
        )}
        {...rest}
      />
      {(error || descriptionText) && (
        <p
          className={cn(
            'text-xs',
            error ? 'text-red-500' : 'text-muted-foreground'
          )}
        >
          {error || descriptionText}
        </p>
      )}
    </div>
  );
};

export default TextareaWithLabel;
